import React, { useState, Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import Button from "../form/Button";
import Input from "../form/Input";
import { Link } from "react-router-dom";

import { postData } from "../../services/api";
import toastr from "toastr";
import { useTranslation } from "react-i18next";
import Image from "../elements/Image";
import { MAIN_LOGO } from "../../constant/Constant";

const ManageInviteBoardMemberPopup = ({
  isOpen,
  setIsOpen = () => {},
  data,
  getActionValue = () => {},
  type,
}) => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);

  const closeModal = () => {
    setIsOpen(false);
  };

  const onSubmit = async () => {
    setIsSubmit(true);
    try {
      const result = await postData("board-member/invitation-send", {
        email: email,
        id: data?._id,
      });
      if (result.status && result.status === 200) {
        getActionValue({
          button_type: "edit",
          row_id: data,
          current_status: "",
          email: email,
        });
        setIsOpen(false);
        setIsSubmit(false);
        toastr.success(result.message);
      } else {
        toastr.error(result.message);
        setIsSubmit(false);
      }
    } catch (error) {
      toastr.error(error.message);
      setIsSubmit(false);
    }
  };

  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-50" onClose={() => {}}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>
          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform rounded-2xl bg-white p-4 text-left align-middle shadow-xl transition-all">
                  <Link to={"/"}>
                    <div className="h-14 w-full flex justify-center object-contain mb-5">
                      <Image
                        src={MAIN_LOGO}
                        alt={""}
                        width={"100%"}
                        height={"100%"}
                        classes={"object-contain object-center"}
                      />
                    </div>
                  </Link>
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900 text-center"
                  >
                    {t("invite_message")}
                  </Dialog.Title>
                  {/* <p className='text-center text-sm'>{t('newslatter_subheading')}</p> */}
                  <hr className="mt-3"></hr>
                  <>
                    <div className="relative mt-4">
                      <div className="relative mb-3">
                        <Input
                          label={t("email")}
                          labelClasses={"!text-xs"}
                          inputType={"text"}
                          inputPlaceholder={t("enter_email")}
                          inputValue={email}
                          setInput={setEmail}
                        />
                      </div>
                    </div>
                    <div className="relative flex justify-center gap-4">
                      <Button
                        buttonClasses=""
                        buttonLabelClasses=""
                        buttonType={"button"}
                        buttonIcon={
                          isSubmit
                            ? "fa-light fa-spinner fa-spin"
                            : "fa-light fa-arrow-right-to-arc"
                        }
                        buttonIconPosition={"left"}
                        buttonLabel={t("submit")}
                        functions={onSubmit}
                        buttonHasLink={false}
                        buttonDisabled={isSubmit}
                      />
                      <Button
                        buttonLabelClasses=""
                        buttonType={"button"}
                        buttonIcon={"fa-light fa-times"}
                        buttonIconPosition={"left"}
                        buttonLabel={t("cancel")}
                        buttonClasses={
                          "!bg-slate-200 !text-slate-600 border border-slate-300"
                        }
                        functions={closeModal}
                        buttonHasLink={false}
                      />
                    </div>
                  </>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export default ManageInviteBoardMemberPopup;
